import type { SoundUtil } from '@chesscom/web-ui';
import type { ThemeAssets } from 'chessboard/config/theme-assets';
import type { Board } from 'chessboard/model/board/types';

export namespace Sounds {
  export interface Model {
    destroy: () => void;
    getSounds: () => SoundObject;
    getTheme: () => string;
    load: (params: LoadParams) => void;
    loadExtra: (params: LoadExtraParams) => void;
    play: (code: BoardSounds) => string;
  }

  export interface API {
    get: () => Model | undefined;
  }

  export type PlayResponse = null | Promise<undefined | string | void>;

  export namespace Plugin {
    export const Name = 'sounds';
  }

  export interface CreateParams {
    options: Board.Options;
    codes?: BoardSounds[];
    soundAssets?: ThemeAssets.SoundAssets;
  }

  export interface LoadParams {
    theme: string;
    codes?: BoardSounds[];
    soundAssets?: ThemeAssets.SoundAssets;
  }

  export interface LoadExtraParams {
    baseURL: string;
    codes: string[];
  }

  export interface SoundElements {
    [key: string]: HTMLAudioElement;
  }

  /**
   * Default codes for the chessboard.
   */
  export enum BoardSounds {
    GameStart = 'game-start',
    GameEnd = 'game-end',
    Capture = 'capture',
    Castle = 'castle',
    Premove = 'premove',
    MoveSelf = 'move-self',
    MoveCheck = 'move-check',
    MoveOpponent = 'move-opponent',
    Promote = 'promote',
    Notify = 'notify',
    TenSeconds = 'tenseconds',
    Illegal = 'illegal',
  }

  export interface SoundObject {
    [BoardSounds.GameStart]: SoundUtil.Sound;
    [BoardSounds.GameEnd]: SoundUtil.Sound;
    [BoardSounds.Capture]: SoundUtil.Sound;
    [BoardSounds.Castle]: SoundUtil.Sound;
    [BoardSounds.Premove]: SoundUtil.Sound;
    [BoardSounds.MoveSelf]: SoundUtil.Sound;
    [BoardSounds.MoveCheck]: SoundUtil.Sound;
    [BoardSounds.MoveOpponent]: SoundUtil.Sound;
    [BoardSounds.Promote]: SoundUtil.Sound;
    [BoardSounds.Notify]: SoundUtil.Sound;
    [BoardSounds.TenSeconds]: SoundUtil.Sound;
    [BoardSounds.Illegal]: SoundUtil.Sound;
  }
}
